import { formatTime12Hour, getDateForHome, getTodaysDate, updateDateWithTime } from './../../config/utils';
import { CabModalData, HrDetails, ICommonStoreState } from "./types";
import addDays from "../../../../utils/date-utils/addDays";
import { generateTimeList, timeAMPMToTime } from "../../config/utils";
import { AT_MODAL_DETAILS, DEFAULT_HR_PACKAGE, DEFAULT_HR_PACKAGE_TIME, HR_PACKAGE_DETAILS, ONEWAY_INTERLINKING_DATA, OS_MODAL_DETAILS, SET_ONEWAY_CAB, UPDATE_HR_PACKAGE, UPDATE_HR_PACKAGE_TIME, UPDATE_DESTINATION_LOCUS, UPDATE_SOURCE_LOCUS, UPDATE_MULTICITY_STOPOVERS, UPDATE_PREVIOUS_MULTICITY_STOPOVERS } from '../../pages/SearchPage/redux/action-types';
import { UPDATE_SEO_FLOW, SET_FLOW } from '../../config/constants';
import dateformat from "dateformat";
import { UPDATE_CABS_CONFIG_DATA, UPDATE_CAB_FAQ_DATA } from './action-types';
const newDate = getTodaysDate();
const time = generateTimeList(newDate.getHours(), newDate.getMinutes());
const initialState: ICommonStoreState = {
  startDate: {
    date: addDays(new Date(), 1),
    time: dateformat(getDateForHome(1), 'hh:MM TT'),
  },
  endDate: {
    date: addDays(new Date(), 2),
    time: dateformat(getDateForHome(2), 'hh:MM TT'),
  },
  source: {},
  previousDestination: {},
  previousSource: {},
  source_locus: {},
  destination: {},
  destination_locus: {},
  tripType: {
    name: "ONE_WAY",
    rf: "ow",
  },
  partner: 'cars',
  selectedCab: {},
  gotribe: {},
  pageMakerResponse: {},
  isSeo: false,
  flow: '',
  pc: '',
  package_id: '',
  packageTime: '',
  defaultPackageId: '', // for SEO City FLow
  defaultPackageTime: '', // for SEO City FLow
  sem_flow: false,
  utm_medium:'',
  utm_campaign:'',
  showQueryCB:false,
  metaData: {},
  osModalDetails: {} as CabModalData,
  atModalDetails: {} as CabModalData,
  hrPackageDetails: {} as HrDetails,
  isOneWayCab: false,             // for this pathname "/cars/one-way-cab/"
  oneway_interlinking_data: [],    // for this pathname "/cars/one-way-cab/"
  faqData: [],
  stopOvers: [],
  previousStopOvers: [],
  configData: {}
};

export default function commonReducer(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_START_DATE":
      if ((state.tripType.rf === "rt" || state.configData.multicity) && new Date(state.endDate.date).getTime() - new Date(action.date).getTime() > 86400) {
        return {
          ...state,
          startDate: {
            ...state.startDate,
            date: updateDateWithTime(action.date, state.startDate.time)
          }
        };
      } else {
        return {
          ...state,
          startDate: {
            ...state.startDate,
            date: updateDateWithTime(action.date, state.startDate.time)
          },
          endDate: {
            ...state.endDate,
            date: addDays(action.date, 1)
          }
        };
      }

      case "UPDATE_END_DATE": {
        const startDate = timeAMPMToTime(state.startDate.date, state.startDate.time);
        const endDate = timeAMPMToTime(action.date, state.endDate.time);
      
        // Calculate the time difference in hours
        const timeDifferenceInHours = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60);
      
        // Check if the end date is the same as the start date and the time difference is less than 12 hours
        if (startDate.toDateString() === endDate.toDateString() && timeDifferenceInHours < 12) {
          // Adjust the end time to be 12 hours after the start time
          endDate.setHours(startDate.getHours() + 12);
          endDate.setMinutes(startDate.getMinutes());
          endDate.setSeconds(0);
          endDate.setMilliseconds(0);
        }
      
        return {
          ...state,
          endDate: {
            ...state.endDate,
            date: updateDateWithTime(action.date, state.endDate.time),
            time: formatTime12Hour(endDate)
          },
        };
      }
    case "UPDATE_SOURCE":
      return {
        ...state,
        source: action.source,
        source_locus: action?.source?.locus || {},
      };

    case "UPDATE_PREVIOUS_SOURCE":
      return {
        ...state,
        previousSource: action.previousSource
      };

    case UPDATE_SOURCE_LOCUS:
      return {
        ...state,
        source_locus: action.locusData,
      };

    case UPDATE_MULTICITY_STOPOVERS:
      return {
        ...state,
        stopOvers: action.stopOvers,
      };

    case UPDATE_PREVIOUS_MULTICITY_STOPOVERS:
      return {
        ...state,
        previousStopOvers: action.previousStopOvers,
      };
    case "UPDATE_START_TIME": {
      // update date object with time
      const newDate = updateDateWithTime(state.startDate.date, action.time);

      // Ensure minimum 12-hour delta between start and end times
      const endDate = new Date(state.endDate.date);
      const startTime = timeAMPMToTime(state.startDate.date, action.time);
      const endTime = timeAMPMToTime(state.endDate.date, state.endDate.time);
      
      const timeDifferenceInHours = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60);
      const isSameDay = newDate.toDateString() === endDate.toDateString();
      const isTimeDifferenceLessThan12Hours = timeDifferenceInHours < 12;
      
      if (isSameDay && isTimeDifferenceLessThan12Hours) {
        if (action.time?.includes('PM')) {
          // If start time includes PM, update the drop date to the next day
          endDate.setDate(endDate?.getDate() + 1);
        } else {
          // If start time does not include PM, update the drop time to ensure a 12-hour gap
          endDate.setHours(startTime.getHours() + 12);
          endDate.setMinutes(startTime.getMinutes());
        }
      }
      return {
        ...state,
        startDate: {
          ...state.startDate,
          date: newDate,
          time: action.time,
        },
        endDate: {
          ...state.endDate,
          date: endDate,
          time: formatTime12Hour(endDate),
        },
      };
    }
      case "UPDATE_END_TIME":
        // update date object with time
        const newEndDate = updateDateWithTime(state.endDate.date, action.time);
        return {
          ...state,
          endDate: {
            ...state.endDate,
            date: newEndDate,
            time: action.time,
          },
        };
    case "UPDATE_DESTINATION":
      return {
        ...state,
        destination: action.destination,
        destination_locus: action?.destination?.locus || {},
      };

    case "UPDATE_PREVIOUS_DESTINATION":
      return {
        ...state,
        previousDestination: action.previousDestination
      };
    case UPDATE_DESTINATION_LOCUS:
      return {
        ...state,
        destination_locus: action.locusData,
      };
    case "UPDATE_SRC_AND_DESC":
      return {
        ...state,
        source: { ...state.destination },
        destination: { ...state.source },
      };
    case "UPDATE_TRIP_TYPE":
      return {
        ...state,
        tripType: action.tripType,
      };
    case UPDATE_SEO_FLOW:
      return {
        ...state,
        isSeo: action.isSeo,
      };
    case 'UPDATE_PARTNER':
      return {
        ...state,
        partner: action.partner
      }
    case 'UPDATE_RECENT_SEARCH':
      let newData = {
        startDate: {
        date: addDays(getTodaysDate(), 1),
        time: dateformat(getDateForHome(1), 'hh:MM TT'),
      },
        endDate: {
          date: addDays(getTodaysDate(), 2),
          time: dateformat(getDateForHome(2), 'hh:MM TT'),
        },
        source: {},
        destination: {}
      };
      if (action.data) {
        newData = action.data;
      }
      if(action.data?.source && action.data?.source?.locus){
        newData.source_locus = action.data?.source?.locus;
      }
      if(action.data?.destination && action.data?.destination?.locus){
        newData.destination_locus = action.data?.destination?.locus;
      }
      return {
        ...state,
        ...newData
      }
    case 'UPDATE_GOTRIBE': 
      return {
        ...state,
        gotribe: {
          ...state.gotribe,
          ...action.gotribe
        }
      }
    case 'UPDATE_PAGEMAKER_RESPONSE': 
      return {
        ...state,
        pageMakerResponse: {
          ...state.pageMakerResponse,
          ...action.pageMakerResponse
        }
      }
    case UPDATE_CAB_FAQ_DATA: 
      return {
        ...state,
        faqData: action.faqData
      }

    case UPDATE_CABS_CONFIG_DATA:
      return {
        ...state,
        configData: action.configData
      }
    case 'UPDATE_METASEO_DATA':
      return {
        ...state,
        metaData: action.metaData
      }
    case "SET_SEM_FLOW":
      return {
        ...state,
        sem_flow: action.sem_flow,
        utm_campaign : action.utm_campaign,
        utm_medium : action.utm_medium
      }
    case SET_FLOW:
      return {
        ...state,
        flow: action.flow
      }

    case "SHOW_QUERY_CB":
      return {
        ...state,
        showQueryCB:action.showQueryCB || false
      } 
    case HR_PACKAGE_DETAILS : {
      return {
        ...state,
        hrPackageDetails : action.hrPackageDetails
      }
    }
    case UPDATE_HR_PACKAGE: 
      return {
        ...state,
        package_id : action.package_id
      }
    case UPDATE_HR_PACKAGE_TIME : 
      return {
        ...state,
        packageTime : action.packageTime
      }
    case DEFAULT_HR_PACKAGE: 
      return {
        ...state,
        defaultPackageId : action.defaultPackageId
      }

    // For SEO City Flow Back handling for rental
    case DEFAULT_HR_PACKAGE_TIME : 
      return {
        ...state,
        defaultPackageTime : action.defaultPackageTime
      }
    case OS_MODAL_DETAILS: 
      return {
        ...state,
        osModalDetails : action.osModalDetails
      }
    case AT_MODAL_DETAILS: 
      return {
        ...state,
        atModalDetails : action.atModalDetails
      }
    case SET_ONEWAY_CAB:
      return {
        ...state,
        isOneWayCab: action.isOneWayCab
      }
    case ONEWAY_INTERLINKING_DATA:
      return {
        ...state,
        oneway_interlinking_data: action.oneWayInterlinks
      }

    default:
      return state;
  }
}